export const ACCESS_TOKEN = "dream5_access_token";
export const SAS_TOKEN = "sas_token";
export const AZURE_BLOB_ACCOUNT_NAME =
  process.env.REACT_APP_AZURE_ACCOUNT_NAME || "testdream5";
export const STRIPE_PUBLIC_KEY =
  process.env.REACT_APP_STRIPE_PUBLIC_KEY ||
  "pk_test_51Iuh1EIiu9ibbMvKVoT5bkAMHaNlpOyibUITK9Gdkxs9T2Xkrldl0C3U8Swe2dNllHRoJuF8Cbpu5QRnPMa3jHJ600CfaKTG9z";
export const CDN_NAME = "dream5publiccdn";
export const GTM_KEY_VALUE = process.env.REACT_APP_GTM_KEY || "";
